import {BaseGameTemplateAnimationSetModel} from "./base-game-template-animation-set-model";

export class gameStatusChangedTemplateAnimationSetModel extends BaseGameTemplateAnimationSetModel {
  get eventLogo() {
    return null;
  }
}
